// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import ExpiringSubscribers from "../../components/dashboard/ExpiringSubscribers";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <ExpiringSubscribers />
    </DashboardLayout>
  );
}
